import { h } from "@stencil/core";
import { injectFont, injectCSS } from "../../utils";
import { createStyles } from "./headline-styles";
export class DcUiHeadline {
    constructor() {
        this.tag = 'h1';
        this.textAlign = 'left';
        this.color = 'inherit';
        this.noMargin = false;
    }
    componentWillLoad() {
        injectFont();
    }
    render() {
        // injectCSS(this.el, this.createStyles());
        injectCSS(this.el, createStyles, this.tag, this.variant, this.color, this.textAlign, this.noMargin);
        return (h(this.tag, { key: 'fe79e8b1288da78978d5905de42b2931352fefdd' }, h("slot", { key: '90c97fcacf05681fcd82e0fb3beafa1106e072e4' })));
    }
    static get is() { return "dc-ui-headline"; }
    static get encapsulation() { return "shadow"; }
    static get properties() {
        return {
            "tag": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "THeadlineTag",
                    "resolved": "\"h1\" | \"h2\" | \"h3\" | \"h4\" | \"h5\" | \"h6\"",
                    "references": {
                        "THeadlineTag": {
                            "location": "import",
                            "path": "./headline-utils",
                            "id": "src/components/dc-ui-headline/headline-utils.ts::THeadlineTag"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "tag",
                "reflect": false,
                "defaultValue": "'h1'"
            },
            "textAlign": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TTextAlign",
                    "resolved": "string | { base?: \"center\" | \"left\" | \"right\"; xs?: \"center\" | \"left\" | \"right\"; sm?: \"center\" | \"left\" | \"right\"; md?: \"center\" | \"left\" | \"right\"; lg?: \"center\" | \"left\" | \"right\"; xl?: \"center\" | \"left\" | \"right\"; } & { base: \"center\" | \"left\" | \"right\"; }",
                    "references": {
                        "TTextAlign": {
                            "location": "import",
                            "path": "../dc-ui-text/text-utils",
                            "id": "src/components/dc-ui-text/text-utils.ts::TTextAlign"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "text-align",
                "reflect": false,
                "defaultValue": "'left'"
            },
            "color": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TTextColor",
                    "resolved": "string | { base?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; xs?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; sm?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; md?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; lg?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; xl?: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; } & { base: \"turquoise01\" | \"darkBlue02\" | \"inherit\" | \"black\" | \"white\" | \"redBrand01\" | \"turquoise04\" | \"grey06\" | \"green02\" | \"yellow02\" | \"red02\" | \"red03\"; }",
                    "references": {
                        "TTextColor": {
                            "location": "import",
                            "path": "../dc-ui-text/text-utils",
                            "id": "src/components/dc-ui-text/text-utils.ts::TTextColor"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "color",
                "reflect": false,
                "defaultValue": "'inherit'"
            },
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "THeadlineVariant",
                    "resolved": "\"h-big\" | \"h-superbig\" | \"h1\" | \"h2\" | \"h3\" | \"h4\" | \"h5\" | \"h6\"",
                    "references": {
                        "THeadlineVariant": {
                            "location": "import",
                            "path": "./headline-utils",
                            "id": "src/components/dc-ui-headline/headline-utils.ts::THeadlineVariant"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "variant",
                "reflect": false
            },
            "noMargin": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "no-margin",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=dc-ui-headline.js.map
